import { Component, OnInit } from '@angular/core';
import { HttpClientAuthServiceService } from '../../httpServices/http-client-auth-service.service'
import { AlertasService } from '../../alerta_servicio/alertas.service'
import { GetPendingPaymentsService } from '../../httpServices/get-pending-payments.service'
import { FormGroup } from '@angular/forms';
import { payments } from './payments.model';
@Component({
  selector: 'app-consulta-pagos',
  templateUrl: './consulta-pagos.component.html',
  styleUrls: ['./consulta-pagos.component.css']
})
export class ConsultaPagosComponent implements OnInit {

  public selectedItem : any;
  public identificationItem: any;
  public lastId: string;
  public lastTypeId : string;

  public from : FormGroup;

  pendingPayments: any[] = [];

  public nombreDeudor : string;
  public showTable : boolean;

  constructor(protected httpService: HttpClientAuthServiceService, private alertas:AlertasService,
    protected getPendingPaymentsService: GetPendingPaymentsService) { }

  ngOnInit(): void {

    this.httpService.login();

  }

  getExtracto(pendingPayments_: payments ){

     this.getPendingPaymentsService.getExtractoService_(pendingPayments_.fechaVencimiento+"_"+pendingPayments_.referencia).subscribe((archivo: Blob) => {
      const tipo = archivo.type;
      const nombre = 'Extracto_'+pendingPayments_.referencia;

      const url = URL.createObjectURL(archivo);
      const enlace = document.createElement('a');

      enlace.href = url;
      enlace.download = nombre;
      enlace.click();

      URL.revokeObjectURL(url);
    },
    (error) => {
      this.alertas.showError("El extracto aun no ha sido generado","Importante");
    }

    );

  }

  getPendingPayments()
  {

    if(this.selectedItem != null && this.identificationItem != null &&
      (this.selectedItem != this.lastTypeId || this.identificationItem != this.lastId))
    {
      this.getPendingPaymentsService.getPendingPayments_(this.selectedItem,this.identificationItem).subscribe(
        (data) => {
          // Success
          this.pendingPayments = data.body['data']['detalleCobrosActivosDeudorDTO'];

          if(this.pendingPayments.length > 1)
            this.showTable = true;
          else
            this.showTable = true;

          this.nombreDeudor = data.body['data']['nombre'];
          this.lastId = this.identificationItem;
          this.lastTypeId = this.selectedItem;
        },
        (error) => {
          this.lastId = this.identificationItem;
          this.lastTypeId = this.selectedItem;
          this.showTable=false;
          this.alertas.showError(error.error["message"],"Error obteniendo información de pendientes");
        }
      );
    }
  }

}
